import React from 'react'

const CreateBusinessArea = function () {
  return (
    <>
      <span>Create Business Area</span>
    </>
  )
}

export default CreateBusinessArea
